export default "__VITE_ASSET__C4$Sr8MO__"